const SpinnerInline = ({ children }) => {
  return children;
};
export {
  SpinnerInline
};
